/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';

/**
 * Wrapper Service used for logging messages into console with various log levels
 */
@Injectable({providedIn: 'root'})
export class LoggerService {

  /**
   * Private method for logging in console
   * @param {string} level
   * @param {string} log_tag
   * @param {string} message
   * @param {boolean} logOnServer
   * @param {Object} data Object data or null
   */
  private _log(level: string, log_tag: string, message: string, logOnServer: boolean, data: unknown = null): void {

    let color1: string;
    switch (level) {
      case 'TRACE':
        color1 = 'blue';
        break;
      case 'DEBUG':
        color1 = 'teal';
        break;
      case 'INFO':
      case 'LOG':
        color1 = 'gray';
        break;
      case 'WARN':
        color1 = 'darkorange';
        break;
      case 'ERROR':
        color1 = 'red';
        break;
      case 'OFF':
      default:
        return;
    }

    if (data) {
      console.log(`%c${dayjs().format('HH:mm:ss')} [${level}] ${log_tag}: %c${message}`,
        `color:${color1}`,
        `color:black`,
        data);
    } else {
      console.log(`%c${dayjs().format('HH:mm:ss')} [${level}] ${log_tag}: %c${message}`,
        `color:${color1}`,
        `color:$black`);
    }
  }

  /**
   * Log in console with log level TRACE
   *
   * @param {string} log_tag A TAG identifying who is logging. Usually the name of the class
   * @param {string} message
   * @param {Object} data Additionnal data or null
   */
  public trace(log_tag: string, message: string, data: unknown = null): void {
    this._log('TRACE', log_tag, message, true, data);
  }

  /**
   * Log in console with log level DEBUG
   *
   * @param {string} log_tag A TAG identifying who is logging. Usually the name of the class
   * @param {string} message
   * @param {Object} data Additionnal data or null
   */
  public debug(log_tag: string, message: string, data: object = null): void {
    this._log('DEBUG', log_tag, message, true, data);
  }

  /**
   * Log in console with log level INFO
   *
   * @param {string} log_tag A TAG identifying who is logging. Usually the name of the class
   * @param {string} message
   * @param {Object} data Additionnal data or null
   */
  public info(log_tag: string, message: string, data: object = null): void {
    this._log('INFO', log_tag, message, true, data);
  }

  /**
   * Log in console with log level LOG
   *
   * @param {string} log_tag A TAG identifying who is logging. Usually the name of the class
   * @param {string} message
   * @param {Object} data Additionnal data or null
   */
  public log(log_tag: string, message: string, data: object = null): void {
    this._log('LOG', log_tag, message, true, data);
  }

  /**
   * Log in console with log level WARN
   *
   * @param {string} log_tag A TAG identifying who is logging. Usually the name of the class
   * @param {string} message
   * @param {Object} data Additionnal data or null
   */
  public warn(log_tag: string, message: string, data: object = null): void {
    this._log('WARN', log_tag, message, true, data);
  }

  /**
   * Log in console with log level ERROR
   *
   * @param {string} log_tag A TAG identifying who is logging. Usually the name of the class
   * @param {string} message
   * @param {Object} data Additionnal data or null
   */
  public error(log_tag: string, message: string, data: Object = null): void {
    this._log('ERROR', log_tag, message, true, data);
  }
}
